import React, { useState, useContext, useEffect } from 'react';
import { toast } from 'react-toastify';
import { auth, db, timestamp, secondaryApp } from '../firebase';

const AuthContext = React.createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  async function signup(email, password, username) {
    await secondaryApp.auth().createUserWithEmailAndPassword(email, password)
      .then(cred => {
        return db.collection('users').doc(cred.user.uid).set({
          role: 'user',
          username: username,
          email: email,
          displayLogo: '',
          links: {
            overview: '',
            facebook: '',
            klaviyo: ''
          },
          invoices: [],
          dateCreated: timestamp()
        }).then(() => {
          updateProfile(username)
            .then(() => {
              //I don't know if the next statement is necessary 
              secondaryApp.auth().signOut();
              toast.info(`User ${username} successfully created`);
            })
        }).catch(err => { return err })
    })
  }

  function login(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
  }

  function logout() {
    localStorage.setItem("hasVisited", false)
    return auth.signOut();
  }

  function resetPassword(email) {
    return auth.sendPasswordResetEmail(email);
  }

  function updateEmail(email) {
    return auth.currentUser.updateEmail(email)
  }

  function updateProfile(displayName, photoURL) {
    return auth.currentUser.updateProfile(
      {
        displayName: displayName,
        photoURL: photoURL
      })
  }
  function updatePassword(password) {
    return auth.currentUser.updatePassword(password)
  }

  async function getUserFromDatabase(uid) {
    try {
      const getUsers = await db
        .collection('users')
        .doc(uid)
        .get();

      const userData = getUsers.data()
      return userData
    } catch (err) {
      console.log(err)
    }
  };

  async function getDisplayLogo(uid) {
    try {
      const getProfilePics = await db
        .collection('displaylogo')
        .doc(uid)
        .get();

      const displayPhoto = getProfilePics.data()
      return displayPhoto
    } catch (err) {
      console.log(err)
    }
  }


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        getUserFromDatabase(user.uid).then(userData => {
          getDisplayLogo(user.uid).then(displayPhoto => {
            setCurrentUser({ ...user, ...userData, ...displayPhoto })
          })
        })
      } else {
        setCurrentUser(user)
      }
      setLoading(false)
    })
    return unsubscribe
  }, [])


  const value = {
    currentUser,
    login,
    signup,
    logout,
    resetPassword,
    updateEmail,
    updatePassword,
    updateProfile,
  }
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
